import MailboxLoadStateEnum from '../store/schema/MailboxLoadStateEnum';
import getMailboxTable from './getMailboxTable';

export default function getMailboxLoadingState(mailboxIdentifier: string): MailboxLoadStateEnum {
    const mailboxTable = getMailboxTable();
    const mailbox = mailboxTable && mailboxTable.get(mailboxIdentifier);
    return (mailbox && mailbox.loadingState) || MailboxLoadStateEnum.Uninitialized;
}
